import type { MechKey } from './keys';

export const mr: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'यांत्रिकी · 2D',
  'panel.scene': 'दृश्य',
  'panel.dims': 'मापदंड',
  'panel.style': 'स्वरूप',
  'panel.action': 'नियंत्रण',
  'style.body': 'वस्तू',
  'style.vector': 'सदिश',
  'style.ground': 'जमीन',
  'style.forces': 'बल दाखवा',
  'style.trace': 'मार्ग दाखवा',
  'style.labels': 'सदिश लेबले',
  'hint.line1': 'सुरू करण्यासाठी प्ले क्लिक करा · वस्तू ओढा',
  'hint.line2': 'सँडबॉक्स: आकार निवडा, मग ठेवण्यासाठी क्लिक करा',
  'scene.incline': 'आनत तल',
  'scene.projectile': 'प्रक्षेपक गती',
  'scene.pendulum': 'लोलक',
  'scene.springMass': 'स्प्रिंग-वस्तुमान यंत्रणा',
  'scene.collisions': 'आघात',
  'scene.atwood': 'एटवुड यंत्र',
  'scene.circular': 'वर्तुळाकार गती',
  'scene.sandbox': 'सँडबॉक्स',
  'dim.angle': 'कोन (°)',
  'dim.friction': 'घर्षण',
  'dim.mass': 'वस्तुमान',
  'dim.massA': 'वस्तुमान A',
  'dim.massB': 'वस्तुमान B',
  'dim.velocity': 'वेग',
  'dim.angleLaunch': 'प्रक्षेपण कोन (°)',
  'dim.gravity': 'गुरुत्व',
  'dim.gravityX': 'गुरुत्व x',
  'dim.gravityY': 'गुरुत्व y',
  'dim.length': 'लांबी',
  'dim.damping': 'अवमंदन',
  'dim.spring': 'कठीणपणा',
  'dim.restitution': 'प्रत्यास्थता',
  'dim.radius': 'त्रिज्या',
  'dim.speed': 'वेग परिमाण',
  'action.play': 'चालवा',
  'action.pause': 'थांबवा',
  'action.step': 'पाऊल',
  'action.reset': 'पुनर्स्थापित करा',
  'action.speed': 'गती',
  'action.clear': 'साफ करा',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'गुरुत्वाकर्षण',
  'forceName.normal': 'अभिलंब बल',
  'forceName.friction': 'घर्षण बल',
  'forceName.tension': 'तणाव',
  'forceName.spring': 'स्प्रिंग बल',
  'forceName.applied': 'आरोपित बल',
  'forceName.air': 'वायू प्रतिरोध',
  'palette.box': 'पेटी',
  'palette.circle': 'चेंडू',
  'palette.ramp': 'उतार',
  'palette.ground': 'जमीन',
  'palette.hint': 'आकार निवडा, मग ठेवण्यासाठी कॅनव्हासवर क्लिक करा.',
  'panel.forces': 'दिसलेली बले',
  'forces.empty': 'अद्याप काहीही नाही — दृश्य चालवा',
};
